import React from 'react';
import { Button, Result } from 'antd';
import { useTranslation } from 'react-i18next';
import { logout } from 'utils/auth';
import LanguageSwitcher from 'components/LanguageSwitcher';

const NoPermissionPage: React.FC = () => {
    const { t } = useTranslation();

    return (
        <div className="flex items-center justify-center h-screen bg-gray-50">
            <div className="absolute top-4 right-4">
                <LanguageSwitcher />
            </div>
            <Result
                status="404"
                title={t('noPermission.title')}
                subTitle={t('noPermission.subtitle')}
                extra={
                    <Button type="primary" onClick={logout}>
                        {t('noPermission.backToLogin')}
                    </Button>
                }
            />
        </div>
    );
};

export default NoPermissionPage;
